import React from 'react';
import { Button } from '@/components/ui/button';
import { ShieldCheck, CloudRain } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { trackSignupIntent } from '@/lib/tracking';

const CallToAction: React.FC = () => {
  const appSignUpUrl = import.meta.env.VITE_APP_URL
    ? `${import.meta.env.VITE_APP_URL}/auth?mode=signup`
    : 'http://localhost:3000/auth?mode=signup';

  return (
    <Card className="my-8 bg-primary/5 dark:bg-primary/10 border-primary/20">
      <CardContent className="p-6 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-start space-x-4">
          <div className="bg-primary/10 text-primary p-3 rounded-full flex-shrink-0">
            <ShieldCheck className="h-6 w-6" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Audit-Proof Your Inspections</h3>
            <p className="text-sm text-muted-foreground mt-1">
              Stop relying on paper. Use our free tools or upgrade to full automation.
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto flex-shrink-0">
           <Button variant="outline" className="w-full sm:w-auto border-primary/20 text-primary hover:bg-primary/5" asChild>
              <Link to="/tools/rain-event-finder"><CloudRain className="mr-2 h-4 w-4"/> Check Rain Data</Link>
           </Button>
           <Button asChild size="lg" className="w-full sm:w-auto">
             <a href={appSignUpUrl} onClick={() => trackSignupIntent('blog_inline_cta')}>Start Free</a>
           </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default CallToAction;
